/*
 * WARNING: This file was automatically generated.
 * Changes must be made to the package.templateroot, or they will be lost!
 */
export enum IOrigin {
  Strava = 'strava',
  Garmin = 'garmin',
  Healthkit = 'healthkit',
  GoogleFit = 'google-fit',
  Daily = 'daily',
  IfitApp = 'ifit-app',
  Treadmill = 'treadmill',
  Elliptical = 'elliptical',
  Strider = 'strider',
  Bike = 'bike',
  StationaryBike = 'stationary bike',
  ThirdParty = 'third-party',
  Wearable = 'wearable',
  SleepSensor = 'sleep-sensor',
  Website = 'website',
  Fusion = 'fusion',
  Rower = 'rower',
}
